import { IVideoRecallServiceInjectedProps, VideoRecallService } from '$State/VideoRecallFreezerService';
import { AlertTypes } from '$Utilities/Enums/AlertTypes';
import { useAppSnackbar } from '$Utilities/hooks/useAppSnackbar';
import { React } from 'Imports';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';
import { isEncompass } from '$Utilities/integrationPlatform';

interface DeleteRecallDialogProps {
    videoEventId: number;
    open: boolean;
    onDelete: (eventId: number) => void;
    onClose: () => void;
}

const _DeleteRecallDialog = (props: DeleteRecallDialogProps & IVideoRecallServiceInjectedProps) => {
    const { showSnackbarMessage } = useAppSnackbar();

    const handleConfirmClick = async () => {
        try {
            await props.videoRecall.deleteVideoRecall(props.videoEventId);
            showSnackbarMessage({
                message: `Video recall deleted successfully.`,
                alertType: AlertTypes.Success,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
        } catch (error) {
            showSnackbarMessage({
                message: `Unable to delete video recall.`,
                alertType: AlertTypes.Fail,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
            props.onClose();
            return;
        }

        props.onDelete(props.videoEventId);
    };

    return (
        <ConfirmDialog
            isOpen={props.open}
            title={isEncompass ? 'Delete Video Recall' : 'Confirm Delete'}
            contentMessage="Are you sure you want to delete this video recall?"
            acceptButton="Delete"
            cancelButton="Cancel"
            isAlert={isEncompass}
            alertType={AlertTypes.Alert}
            showIcon={isEncompass}
            isButtonAlert
            contentMessageMarginTop={isEncompass ? '0' : undefined}
            handleModalClosed={props.onClose}
            handleSubmit={handleConfirmClick}
        />
    );
};

const DeleteRecallDialog = VideoRecallService.inject(_DeleteRecallDialog);

export default DeleteRecallDialog;
